import { useTranslation } from 'react-i18next';
import { AlertBanner } from 'components/AlertBanner';
import { Link } from 'components/Link';
import { useUser } from 'services/User';
import { isInOrganization } from 'services/accessControl';
import { getLicenseIssue } from 'utils/license';

/** Shown after login when the license is expired or the org has no scan limits (MDCI-984). */
export const LicenseStatusBanner = () => {
    const { t } = useTranslation();
    const { user } = useUser();
    const issue = getLicenseIssue(user);

    if (!issue) {
        return null;
    }

    const licensingLink = <Link to='/licensing'>{t('Licensing')}</Link>;

    if (issue === 'zero-limit') {
        return (
            <AlertBanner
                variant='warning'
                className='tw:mb-12'
                text={
                    <div>
                        {t("Your organization's MetaDefender Cloud license has no scan limits, so scans will not run. See ")}
                        {licensingLink}
                        {t(' for your billing state and limits.')}
                    </div>
                }
            />
        );
    }

    const message = (
        <div>
            {isInOrganization(user)
                ? t("Your organization's MetaDefender Cloud license has expired. See ")
                : t('Your MetaDefender Cloud license has expired. See ')}
            {licensingLink}
            {t(' to renew.')}
        </div>
    );

    return <AlertBanner variant='error' text={message} className='tw:mb-12' />;
};
